export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00843.b14829d6.png";